import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";

const navLinkClass = (active) =>
  [
    "text-sm font-medium transition-colors",
    active ? "text-orange-600" : "text-gray-600 hover:text-orange-600",
  ].join(" ");

/**
 * Public shell for extranet marketing blog pages (no auth sidebar).
 */
const BlogPublicLayout = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isBlogHome = pathname === "/blog" || pathname === "/blog/";

  return (
    <Box className="min-h-screen bg-gray-50 text-gray-900">
      <header className="sticky top-0 z-50 border-b border-gray-200/80 bg-white/95 backdrop-blur-md">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
          <Link
            to="/login"
            className="flex items-center gap-2.5 no-underline"
            aria-label="TabTrips Extranet home"
          >
            <img
              src="/favicon.ico"
              alt=""
              className="h-9 w-9 rounded-lg"
              width={36}
              height={36}
            />
            <span className="text-base font-bold text-gray-900 sm:text-lg">
              TabTrips{" "}
              <span className="font-semibold text-orange-600">Extranet</span>
            </span>
          </Link>

          <nav className="flex flex-wrap items-center justify-end gap-3 sm:gap-5">
            <Link to="/blog" className={navLinkClass(isBlogHome)}>
              Blog
            </Link>
            <Link to="/about-us" className={navLinkClass(pathname === "/about-us")}>
              About
            </Link>
            <Link to="/support" className={navLinkClass(pathname === "/support")}>
              Support
            </Link>
            <button
              type="button"
              onClick={() => navigate("/listing")}
              className="hidden rounded-lg border border-orange-200 bg-orange-50 px-3 py-1.5 text-sm font-semibold text-orange-700 transition hover:bg-orange-100 sm:inline-block"
            >
              List property
            </button>
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="rounded-lg bg-gradient-to-r from-orange-500 to-amber-500 px-3 py-1.5 text-sm font-semibold text-white shadow-sm transition hover:from-orange-600 hover:to-amber-600"
            >
              Partner login
            </button>
          </nav>
        </div>
      </header>

      <main>{children}</main>

      <footer className="mt-16 border-t border-gray-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} TabTrips. Partner extranet — tap, travel, go.
            </p>
            <div className="flex flex-wrap gap-4 text-sm">
              <Link to="/blog" className="font-medium text-gray-600 hover:text-orange-600">
                Blog
              </Link>
              <Link
                to="/listing"
                className="font-medium text-gray-600 hover:text-orange-600"
              >
                Partner registration
              </Link>
              <Link to="/about-us" className="font-medium text-gray-600 hover:text-orange-600">
                About us
              </Link>
              <Link to="/support" className="font-medium text-gray-600 hover:text-orange-600">
                Support
              </Link>
              <Link
                to="/privacy-policy"
                className="font-medium text-gray-600 hover:text-orange-600"
              >
                Privacy
              </Link>
              <Link
                to="/terms-conditions"
                className="font-medium text-gray-600 hover:text-orange-600"
              >
                Terms
              </Link>
              <a
                href="https://tabtrips.com"
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-gray-600 hover:text-orange-600"
              >
                TabTrips.com
              </a>
            </div>
          </div>
        </div>
      </footer>
    </Box>
  );
};

export default BlogPublicLayout;
